import { thunkReducerFactory } from "infrastructure/store/reducers";

export const {
    requestLoading: kycRequestLoading,
    requestFulfilled: kycRequestFulfilled,
    requestRejected: kycRequestRejected
} = thunkReducerFactory();
